import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import styles from "./styles.module.css";

export const ChartTypeTabsPlaceholder = () => {
  return (
    <div className={styles.chartTypeTabsPlaceholder}>
      <Placeholder.Line />
    </div>
  );
};

export const ComparisonChartPlaceholder = () => {
  return (
    <div className={styles.comparisonChartPlaceholder}>
      <Placeholder.Line />
    </div>
  );
};

export const LegendsPlaceholder = ({ rows = 0 }: { rows?: number }) => {
  return (
    <div className={styles.legendsPlaceholder}>
      {Array.from({ length: rows }).map((_, index) => (
        <Placeholder.Line key={`legend-${index}`} />
      ))}
    </div>
  );
};
